import { isSeason, type Season } from './season';

/** Temporary URL preview only; never a saved account or game preference. */
export function localSeasonPreview(search: string, hostname: string): Season | null {
  const host = hostname.toLowerCase();
  if (host !== 'localhost' && !host.endsWith('.localhost') && host !== '127.0.0.1' && host !== '[::1]') {
    return null;
  }
  const value = new URLSearchParams(search).get('theme');
  if (value === 'sakura') return 'cherry-blossom';
  return isSeason(value) ? value : null;
}

export function currentLocalSeasonPreview(search?: string): Season | null {
  if (typeof window === 'undefined') return null;
  return localSeasonPreview(search ?? window.location.search, window.location.hostname);
}
